import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const FinalCTASection = () => {
  return (
    <section className="py-24 bg-muted/30">
      <div className="container mx-auto px-4 max-w-3xl text-center">
        <h2 className="text-3xl md:text-4xl font-semibold text-foreground mb-8">
          Ready to run your first session?
        </h2>
        <Link to="/auth/signup">
          <Button size="lg" className="h-14 px-8 text-lg gap-2 group">
            Start a Remote Viewing Session
            <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
          </Button>
        </Link>
      </div>
    </section>
  );
};

export default FinalCTASection;
